import styled from "@emotion/styled";

export const StyledCreateConversation = styled.div`
  .chats-list {
    max-height: 30dvh;
    overflow-y: scroll;
    .time {
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;
    }
    .recent-conversation {
      border: 1px solid #d9d9d9;
      margin-bottom: 5px;
      border-radius: 10px;
      overflow: hidden;
      .header {
        padding: 10px 10px;
        background: #f5f0ff;

        .right-div {
          gap: 5px;
        }
      }

      .case-title {
        font-weight: 400;
        font-size: 16px;
      }

      .ant-list-item {
        padding-left: 10px;
        padding-right: 10px;
        cursor: pointer;
      }

      .collapse-icon {
        font-size: 20px;
      }
      .ant-empty {
        margin: 0px !important;
        padding: 10px;
      }
    }
  }
`;
